var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.542 2.098c0 1.167-.87 2.098-2.283 2.098h-.026C.871 4.196 0 3.266 0 2.098 0 .905.905 0 2.284 0c1.379 0 2.233.905 2.258 2.098zM.237 18h4.035V5.854H.237V18zm13.94-12.427c-2.14 0-3.096 1.176-3.637 2.005v.034h-.025c.008-.008.016-.025.025-.042V5.854H6.505c.05 1.133 0 12.138 0 12.138h4.035v-6.784c0-.364.025-.727.135-.981.296-.72.956-1.48 2.073-1.48 1.463 0 2.047 1.116 2.047 2.749v6.496h4.035V11.03c0-3.721-1.997-5.456-4.653-5.456z",
    fill: "#00234B"
  })));
}
export default SvgLinkedin;